<template>
  <section
    class="page__section"
    :style="componentStyle"
  >
    <div class="container">
      <section
        class="section__content"
        :class="{ 'section__reverse': layout === 'reverse' }"
      >
        <article
          class="section__media"
          v-if="media"
        >
          <figure v-if="media.type === 'image'">
            <img
              class="img"
              :src="translate(media.image_url) || getImagePath('placeholders/project-card-cover.jpg')"
            >
          </figure>

          <app-video-embed
            v-else-if="media.type === 'video'"
            :src="translate(media.video_url)"
          />
        </article>

        <article class="section__text">
          <app-content
            class="editor__page"
            :content="translate(text)"
          />

          <div
            class="btn__container margin__t--24"
            v-if="button?.show"
          >
            <app-link
              :link="button"
              :style="buttonStyle"
              class="btn btn__size--small btn__color--prim"
            />
          </div>
        </article>
      </section>
    </div>
  </section>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useStyle } from '@/composables/app/useStyle'
import { getImagePath } from '@/utils/utils'

import AppContent from '&/atoms/AppContent'
const AppLink = defineAsyncComponent(() => import('&/atoms/AppLink'))
const AppVideoEmbed = defineAsyncComponent(() => import('&/atoms/AppVideoEmbed'))

const { section } = defineProps({
  section: { type: Object, required: true }
})

const { translate } = useI18n()
const { componentStyle, layout, buttonStyle } = useStyle(section.style)

const { text, button, media } = section.attributes
</script>

<style lang="scss" scoped>
.section {
  &__content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    @include mq(md) {
      display: flex;
    }
  }

  &__text {
    margin-top: 18px;

    @include mq(md) {
      margin: 0;
      width: 50%;
      padding-left: 24px;
    }
  }

  &__media {
    width: 100%;

    @include mq(md) {
      width: 50%;
      padding-right: 18px;
    }
  }

  &__reverse {
    .section__text {
      order: 1;
      margin-bottom: 24px;

      @include mq(md) {
        padding-right: 18px;
        padding-left: 0;
      }
    }

    .section__media {
      order: 2;

      @include mq(md) {
        padding-left: 18px;
        padding-right: 0;
      }
    }
  }
}

.img {
  max-width: 100%;
}
</style>
